module.exports = __webpack_public_path__ + "static/media/exampleCSV.fa0e949c.png";